import { Union, Record } from "../fable_modules/fable-library.3.7.1/Types.js";
import { union_type, class_type, record_type, int32_type, string_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { columnDef_header_Z721C83C5, columnDef_footer_Z5FD1F5D2, columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, ColumnHelper_accessor_36841BC5, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, ColumnHelper_accessor_10721996, ColumnHelper_createColumnHelper_Z2906D979 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { Table_getFooterGroups_Z4395D14A, Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Table_getHeaderGroups_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_Z6DEE00B4, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { map, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { createObj } from "../fable_modules/fable-library.3.7.1/Util.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export class Person extends Record {
    constructor(Firstname, Lastname, Age, Visits, Status, Progress) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Age = (Age | 0);
        this.Visits = (Visits | 0);
        this.Status = Status;
        this.Progress = (Progress | 0);
    }
}

export function Person$reflection() {
    return record_type("Examples.Basic.Person", [], Person, () => [["Firstname", string_type], ["Lastname", string_type], ["Age", int32_type], ["Visits", int32_type], ["Status", string_type], ["Progress", int32_type]]);
}

export const defaultData = [new Person("tanner", "linsley", 24, 100, "In Relationship", 50), new Person("tandy", "miller", 40, 40, "Single", 80), new Person("joe", "dirte", 45, 20, "Complicated", 10)];

export const columnDef = ColumnHelper_createColumnHelper_Z2906D979(ofArray([ColumnHelper_accessor_10721996("firstname", ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_cell_Z1DDB00E5((info) => info.getValue())])), ColumnHelper_accessor_36841BC5((p) => p.Lastname, ofArray([columnDef_id_Z721C83C5("lastName"), columnDef_cell_Z1DDB00E5((info_1) => createElement("i", {
    children: info_1.getValue(),
})), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
})), columnDef_footer_Z5FD1F5D2((info_2) => info_2.column.id)])), ColumnHelper_accessor_10721996("Age", ofArray([columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_cell_Z1DDB00E5((info_3) => info_3.renderValue()), columnDef_footer_Z5FD1F5D2((info_4) => info_4.column.id)])), ColumnHelper_accessor_10721996("Visits", ofArray([columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((info_5) => info_5.column.id)])), ColumnHelper_accessor_10721996("Status", ofArray([columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((info_6) => info_6.column.id)])), ColumnHelper_accessor_10721996("Progress", ofArray([columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((info_7) => info_7.column.id)]))]));

export class State extends Record {
    constructor(Table) {
        super();
        this.Table = Table;
    }
}

export function State$reflection() {
    return record_type("Examples.Basic.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Person$reflection()])]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nop"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.Basic.Msg", [], Msg, () => [[]]);
}

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", defaultData], tableProps_columns_Z2906D979(columnDef)]))), Cmd_none()];
}

export function update(msg, state) {
    return [state, Cmd_none()];
}

export function view(state, dispatch) {
    let elems_6;
    let thead;
    const children = toList(delay(() => map((headerGroup) => {
        let elems_1;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (elems_1 = toList(delay(() => map((header) => {
            let elems;
            return createElement("th", createObj(ofArray([["key", header.id], (elems = [Html_flexRender_Z6DEE00B4(header.column.columnDef.header, Table_getContext_315F98D7(header))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    let tbody;
    const children_4 = toList(delay(() => map((row) => {
        let elems_2;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_2 = toList(delay(() => map((cell) => {
            const children_2 = singleton(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
            return createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            });
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    });
    let tfoot;
    const children_6 = toList(delay(() => map((footerGroup) => {
        let elems_4;
        return createElement("tr", createObj(ofArray([["key", footerGroup.id], (elems_4 = toList(delay(() => map((footer) => {
            let elems_3;
            return createElement("th", createObj(ofArray([["key", footer.id], (elems_3 = [Html_flexRender_Z6DEE00B4(footer.column.columnDef.footer, Table_getContext_315F98D7(footer))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
        }, footerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
    }, Table_getFooterGroups_Z4395D14A(state.Table))));
    tfoot = createElement("tfoot", {
        children: Interop_reactApi.Children.toArray(Array.from(children_6)),
    });
    return createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_6 = [createElement("table", {
        children: Interop_reactApi.Children.toArray([thead, tbody, tfoot]),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])));
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=Basic.fs.js.map
